module.exports = __webpack_public_path__ + "media/images/bundle-optima-dcd810b133655afc4e1ca91796b15d28.png";